import { render, staticRenderFns } from "./add-research-group.html?vue&type=template&id=a99fbeb2&scoped=true&external"
import script from "./add-research-group.js?vue&type=script&lang=js&external"
export * from "./add-research-group.js?vue&type=script&lang=js&external"
import style0 from "./add-research-group.scss?vue&type=style&index=0&id=a99fbeb2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99fbeb2",
  null
  
)

export default component.exports